import React from "react";
import { Helmet } from "react-helmet";
import wedevelopers from "../assets/wedevelopers.jpg"

const Meta = ({ title, description }) => {
  return (
    <Helmet>
      <title>
        {title}
      </title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      {/* <meta name="keyword" content={keywords} /> */}

      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://wedevelopers.io/" />
      <meta
        property="og:title"
        content={title}
      />
      <meta
        property="og:description"
        content={description}
      />
      <meta
        property="og:image"
        content={wedevelopers}
      />

      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content="https://wedevelopers.io/" />
      <meta
        property="twitter:title"
        content={title}
      />
      <meta
        property="twitter:description"
        content={description}
      />
      <meta
        property="twitter:image"
        content={wedevelopers}
      />
    </Helmet>
  );
};

Meta.defaultProps = {
  title:
    "Wedevelopers - Leading software engineering teams and hire top software engineers",
  description:
    "Most Innovative software development company providing top software development services.",
  // keywords:
  //   "become a developer, hire software engineers, build product, senior developers",
};

export default Meta;
